import type {AppRatesState} from '@/context/types';
import RatesTable from '@/screens/Rates/App/RatesTable';
import {applyDiscountToRates} from '@/utils/rates/applyDiscountToRates';
import {convertRatesListToMap} from '@/utils/rates/convertRatesListToMap';

type TierRateTableProps = Partial<AppRatesState> & {
  discount?: number;
};

const TierRateTable = ({
  loading,
  rawAppRates,
  discount,
}: TierRateTableProps) => {
  const discountRates = applyDiscountToRates(rawAppRates ?? [], discount ?? 0);
  const appRates = convertRatesListToMap(discountRates ?? []);
  return (
    <div className="container mx-auto py-6">
      {loading ? <p>Loading...</p> : <RatesTable rates={appRates} />}
    </div>
  );
};

export default TierRateTable;
